import { MetaConversation } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { twilioActions } from '../../../app/middleware/twilio/actions/twilioActions';
import { activityLogActions } from '../../activityLog/actions/activityLog';
import { notificationActions } from '../../notifications/actions/notification';
import { actions as personalActions } from '../../settings/actions/personal';
import { composeEmailActions } from '../../shared/composeEmail/actions/composeEmailActions';
import { followUpModalActions } from '../../shared/followUpModal/actions/followUpModal';
import { transferToAgentActions } from '../../shared/transferToAgentModal/actions/transferToAgentModal';
import { transferToNumberActions } from '../../shared/transferToNumberModal/actions/transferToNumberModal';
import { transferToQueueActions } from '../../shared/transferToQueueModal/actions/transferToQueueModal';
import * as telephonyActions from '../../telephony/actions/telephony';
import { actions } from '../actions/conversation';
import * as conversationsActions from '../actions/conversations';
import { satisfactionActions } from '../actions/satisfaction';
import Conversation from '../components/Conversation';
import { getLatestFacebookConversation } from '../selectors';

const { transferToQueueModalOpen } = transferToQueueActions;
const { transferToNumberModalOpen } = transferToNumberActions;
const { conversationsResetUnread } = conversationsActions.actions;
const { telephonySetMute } = telephonyActions.actions;
const { twilioConnectCall, twilioDisconnectCall } = twilioActions;
const { notificationTabBadgeReset } = notificationActions;
const { transferToAgentModalOpen } = transferToAgentActions;
const {
  getAvailableSatisfactionLanguagesRequest,
  changeSatisfactionLanguageRequest,
  cancelSatisfactionRequest,
} = satisfactionActions;

const mapStateToProps = (state) => {
  return {
    metaConversation: state.conversation.metaConversation,
    asyncStatus: state.conversation.asyncStatus,
    telephony: state.telephony,
    profile: state.settings.profile.profile,
    isMenuOpen: state.settings.personal.isLeftMenuOpen,
    isCustomCardMenuOpen: state.settings.personal.isCustomCardMenuOpen,
    latestMessengerConversation: getLatestFacebookConversation(state),
    availableSatisfactionLanguages:
      state.conversation.availableSatisfactionLanguages,
    isActivityLogOpen: state.activityLog.isOpen,
    isFocusMode: state.conversation.isFocusMode,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    conversationGet: bindActionToPromise(dispatch, actions.conversationGet),
    conversationClaim: bindActionToPromise(dispatch, actions.conversationClaim),
    conversationClose: bindActionToPromise(dispatch, actions.conversationClose),
    conversationTag: bindActionToPromise(dispatch, actions.conversationTag),
    conversationUntag: bindActionToPromise(dispatch, actions.conversationUntag),
    telephonySetMute: bindActionToPromise(dispatch, telephonySetMute),
    twilioConnectCall: bindActionToPromise(dispatch, twilioConnectCall),
    twilioDisconnectCall: bindActionToPromise(dispatch, twilioDisconnectCall),
    notificationTabBadgeReset: () => dispatch(notificationTabBadgeReset()),
    conversationResetUnread: (payload: { csid: string }) =>
      dispatch(conversationsResetUnread(payload)),

    conversationUnmount: () => dispatch(actions.conversationUnmount()),

    transferToQueueModalOpen: (payload: { csid: number }) =>
      dispatch(transferToQueueModalOpen(payload)),
    transferToNumberModalOpen: (metaConversation: MetaConversation) =>
      dispatch(
        transferToNumberModalOpen({ metaConversation: metaConversation }),
      ),
    transferToAgentModalOpen: (metaConversation: MetaConversation) =>
      dispatch(
        transferToAgentModalOpen({ metaConversation: metaConversation }),
      ),

    setToPending: bindActionToPromise(dispatch, actions.conversationToPending),
    cancelPending: bindActionToPromise(
      dispatch,
      actions.conversationCancelPending,
    ),

    followUpModalOpen: bindActionToPromise(
      dispatch,
      followUpModalActions.followUpModalOpen,
    ),
    telephonyMakeCall: bindActionToPromise(
      dispatch,
      twilioActions.twilioMakeCall,
    ),
    composeEmailOpenModal: (payload) =>
      dispatch(composeEmailActions.composeEmailOpenModal(payload)),
    toggleActivityLog: (payload: { open: boolean }) => {
      dispatch(activityLogActions.toggle(payload));
    },

    getAvailableSatisfactionLanguages: (channel, contactPoint) =>
      dispatch(
        getAvailableSatisfactionLanguagesRequest({ channel, contactPoint }),
      ),
    changeSatisfactionLanguage: (csid, language) =>
      dispatch(changeSatisfactionLanguageRequest({ csid, language })),
    cancelSatisfaction: (csid) => dispatch(cancelSatisfactionRequest({ csid })),

    closeSideBarMenu: () =>
      dispatch(
        personalActions.personalCustomCardMenu({
          key: 'isCustomCardMenuOpen',
          value: false,
        }),
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Conversation);
